import Cookies from 'js-cookie';
import { fromUnixTime, add, isBefore } from 'date-fns';
import axios from 'axios';

var ENV = 'production'; // GET and SET ENV

var getEnv = function getEnv() {
  return ENV;
};
var setEnv = function setEnv(env) {
  ENV = env;
};
var setupJsCommon = function setupJsCommon(env) {
  setEnv(env);
};

var KNOWN_API_ERRORS = ['Not found.', 'Unauthorized', 'MFA required', 'User not found', 'Unauthenticated.', 'MFA code expired', 'Unauthenticated.', 'Unauthenticated.', 'Incorrect MFA code', 'Resource not found', 'Account is suspended', 'Invalid Bearer token', 'Invalid refresh token', 'User already confirmed', 'Incorrect captcha code', 'Username already exists', 'Username already exists', 'Billing account not found', 'User is not yet confirmed', 'Invalid username or password.', 'Billing information not found', 'Confirmation code has expired', 'Cannot upgrade this subscription', 'Your MFA code has already been validated', 'Authentication credentials were not provided.', 'You do not have a phone number on your account', 'There was a problem uploading your avatar file', "Unexpected response status from UAA, got: '401'", "Unexpected response status from UAA, got: '403'", "Unexpected response status from UAA, got: '404'", 'Password is required when registering a new user', 'The transaction was declined due to invalid data.', 'You do not have permission to perform this action.', 'Your expiration date is invalid or does not match.', 'Session status must be "started" in order to stop it', 'Your credit card is expired, please update your card.', 'Your password includes characters that are not allowed.', 'Your password must be between 8 and 98 characters long.', 'Your card number is not valid. Please update your card number.', 'Your card must be authenticated with 3-D Secure before continuing.', 'Your account number is not valid. Please update your account number.', 'Your payment details were not found. Please update your billing information.', 'The transaction was declined. Please use a different card or contact your bank.', 'Your transaction was declined. Please use a different card or contact your bank.', 'Your card has a temporary hold. Please use a different card or contact your bank.', 'The security code you entered does not match. Please update the CVV and try again.', '1st coupon code: coupon is not redeemable for any provided subscriptions or charges', 'Please validate information and try again. If the problem persists, please contact your bank.', 'Your card cannot be accepted. Please contact your issuing bank for details or try another card.', 'Your card is not allowed to complete this transaction. Please contact your bank or try another card.', 'Your transaction was declined due to insufficient funds in your account. Please use a different card or contact your bank.', 'Thank you for your interest in the Starter Pass. This is intended for new users and unfortunately, active INE subscribers are unable to sign up at this time. We apologize for the inconvenience.'];
var FRIENDLY_ERRORS = {
  'Resource not found': 'We were unable to locate this content. It may have been moved, deleted, or does not exist.',
  'Invalid username or password.': 'We were unable to log you in with the username and password provided. Please check your entries and try again.',
  'Account is suspended': 'Your account has been suspended. Please contact INE support for assistance.',
  'User is not yet confirmed': 'Please check your email for a registration email with instructions on how to confirm your email address. Otherwise, please contact INE support at support@ine.com',
  'Authentication credentials were not provided.': 'You must be logged in to do that.',
  'Username already exists': 'This username already exists. Do you need to sign in first?',
  '1st subscription: Base you already have a subscription to this plan.': 'You already have a subscription to this plan',
  '1st coupon code: coupon is not redeemable for any provided subscriptions or charges': 'That is not a valid coupon',
  'Cannot upgrade this subscription': 'Unfortunately, your subscription cannot currently be upgraded. Please contact INE support to complete the purchase using the Support link at the bottom of the page.'
};

var COOKIES = {
  DOMAINS: {
    local: 'localhost',
    development: '.development.ine.com',
    staging: '.staging.ine.com',
    production: '.ine.com'
  },
  TYPES: {
    ACCESS: {
      production: 'ine_access_token',
      staging: 'ine_stg_access_token',
      development: 'ine_dev_access_token',
      local: 'ine_local_access_token',
      test: 'ine_test_access_token'
    },
    REFRESH: {
      production: 'ine_refresh_token',
      staging: 'ine_stg_refresh_token',
      development: 'ine_dev_refresh_token',
      local: 'ine_local_refresh_token',
      test: 'ine_test_refresh_token'
    },
    ORIGINAL_USER_ACCESS_TOKEN: {
      production: 'ine_original_access_token',
      staging: 'ine_stg_original_access_token',
      development: 'ine_dev_original_access_token',
      local: 'ine_local_original_access_token',
      test: 'ine_test_original_access_token'
    },
    ORIGINAL_USER_REFRESH_TOKEN: {
      production: 'ine_original_refresh_token',
      staging: 'ine_stg_original_refresh_token',
      development: 'ine_dev_original_refresh_token',
      local: 'ine_local_original_refresh_token',
      test: 'ine_test_original_refresh_token'
    }
  }
};

var BUGSNAG = {
  RELEASE_STAGES: ['production', 'staging', 'development'],
  REDACTED_KEYS: ['email', 'password', 'username', 'last_name', 'first_name', 'phone_number', 'old_password', 'new_password', 'recurly-token', 'confirm_password']
};

var UAA_URLS = {
  test: 'https://localhost/uaa',
  staging: 'https://uaa.ine.com/uaa',
  production: 'https://uaa.ine.com/uaa',
  local: 'https://uaa.development.ine.com/uaa',
  development: 'https://uaa.development.ine.com/uaa'
};
var API_URLS = {
  test: 'https://localhost/api',
  staging: 'https://api.ine.com/api/content/',
  production: 'https://api.ine.com/api/content/',
  local: 'https://api.development.ine.com/api/content/',
  development: 'https://api.development.ine.com/api/content/'
};
var QUIZ_URLS = {
  test: 'https://localhost/quiz',
  production: 'https://quiz.rmotr.com/api/v1/',
  staging: 'https://quiz.staging.rmotr.com/api/v1/',
  local: 'https://quiz.development.rmotr.com/api/v1/',
  development: 'https://quiz.development.rmotr.com/api/v1/'
};
var LAB_URLS = {
  test: 'https://localhost/labs',
  production: 'https://content-api.rmotr.com/api/v1/',
  staging: 'https://content-api.staging.rmotr.com/api/v1/',
  local: 'https://content-api.development.ine.com/api/v1/',
  development: 'https://content-api.development.ine.com/api/v1/'
};
var FILE_URLS = {
  test: 'https://localhost/files',
  production: 'https://file.rmotr.com/api/v1/',
  staging: 'https://file.staging.rmotr.com/api/v1/',
  local: 'https://file.development.rmotr.com/api/v1/',
  development: 'https://file.development.rmotr.com/api/v1/'
};
var VIDEO_URLS = {
  test: 'https://localhost/videos',
  production: 'https://video.rmotr.com/api/v1/',
  staging: 'https://video.staging.rmotr.com/api/v1/',
  local: 'https://video.development.rmotr.com/api/v1/',
  development: 'https://video.development.rmotr.com/api/v1/'
};
var IFRAME_URLS = {
  test: 'https://localhost/iframes',
  production: 'https://content-api.ine.com/api/v1/',
  staging: 'https://content-api.staging.ine.com/api/v1/',
  local: 'https://content-api.development.ine.com/api/v1/',
  development: 'https://content-api.development.ine.com/api/v1/'
};
var PROFILE_URLS = {
  test: 'https://localhost/profiles',
  staging: 'https://profiles.ine.com/',
  production: 'https://profiles.ine.com/',
  local: 'https://profiles.development.ine.com/',
  development: 'https://profiles.development.ine.com/'
};
var CONTENT_URLS = {
  test: 'https://localhost/content',
  production: 'https://content-api.rmotr.com/api/v1/',
  staging: 'https://content-api.staging.rmotr.com/api/v1/',
  local: 'https://content-api.development.ine.com/api/v1/',
  development: 'https://content-api.development.ine.com/api/v1/'
};
var CONTENT_BACKOFFICE_URLS = {
  test: 'https://localhost/content',
  production: 'https://content-api.rmotr.com/backoffice/api/v1/',
  staging: 'https://content-api.staging.rmotr.com/backoffice/api/v1/',
  local: 'https://content-api.development.ine.com/backoffice/api/v1/',
  development: 'https://content-api.development.ine.com/backoffice/api/v1/'
};
var MIXPANEL_URLS = {
  test: 'https://localhost/mixpanel',
  production: 'https://events.rmotr.com/',
  staging: 'https://events.staging.rmotr.com/',
  local: 'https://events.development.rmotr.com/',
  development: 'https://events.development.rmotr.com/'
};
var BUSINESS_URLS = {
  test: 'https://localhost/business',
  staging: 'https://api.ine.com/enterprise/',
  production: 'https://api.ine.com/enterprise/',
  local: 'https://api.development.ine.com/enterprise/',
  development: 'https://api.development.ine.com/enterprise/'
};
var EXERCISE_URLS = {
  test: 'https://localhost/exercise',
  production: 'https://exercise.rmotr.com/api/v1/',
  staging: 'https://exercise.staging.rmotr.com/api/v1/',
  local: 'https://exercise.development.rmotr.com/api/v1/',
  development: 'https://exercise.development.rmotr.com/api/v1/'
};
var STATISTIC_URLS = {
  test: 'https://localhost/statistics',
  staging: 'https://statistics.ine.com/statistics/',
  production: 'https://statistics.ine.com/statistics/',
  local: 'https://statistics.development.ine.com/statistics/',
  development: 'https://statistics.development.ine.com/statistics/'
};
var SUBSCRIPTION_URLS = {
  test: 'https://localhost/subscriptions',
  staging: 'https://subscriptions.ine.com/subscriptions/',
  production: 'https://subscriptions.ine.com/subscriptions/',
  local: 'https://subscriptions.development.ine.com/subscriptions/',
  development: 'https://subscriptions.development.ine.com/subscriptions/'
};
var CERTIFICATION_URLS = {
  test: 'https://localhost/certifcations',
  production: 'https://content-api.rmotr.com/api/v1/',
  staging: 'https://content-api.staging.rmotr.com/api/v1/',
  local: 'https://content-api.development.ine.com/api/v1/',
  development: 'https://content-api.development.ine.com/api/v1/'
};
var BUSINESS_PYTHON_URLS = {
  test: 'https://localhost/business',
  production: 'https://business-api.rmotr.com/api/v1/',
  staging: 'https://business-api.staging.rmotr.com/api/v1/',
  local: 'https://business-api.development.rmotr.com/api/v1/',
  development: 'https://business-api.development.rmotr.com/api/v1/'
};
var REPORTING_URLS = {
  test: 'https://localhost/reporting',
  production: 'https://reporting.rmotr.com/',
  staging: 'https://reporting.staging.rmotr.com/',
  local: 'https://reporting.development.rmotr.com/',
  development: 'https://reporting.development.rmotr.com/'
};
var REPORTING_v2_URLS = {
  test: 'https://localhost/reporting/api/v2/',
  production: 'https://reporting.rmotr.com/api/v2/',
  staging: 'https://reporting.staging.rmotr.com/api/v2/',
  local: 'https://reporting.development.rmotr.com/api/v2/',
  development: 'https://reporting.development.rmotr.com/api/v2/'
};
var TEAMS_API_URLS = {
  test: 'https://localhost/teams',
  production: 'https://teams-api.rmotr.com/v1/',
  staging: 'https://teams-api.staging.rmotr.com/v1/',
  local: 'https://teams-api.development.rmotr.com/v1/',
  development: 'https://teams-api.development.rmotr.com/v1/'
};
var TEAMS_API_v2_URLS = {
  test: 'https://localhost/teams',
  production: 'https://teams-api.rmotr.com/v2/',
  staging: 'https://teams-api.staging.rmotr.com/v2/',
  local: 'https://teams-api.development.rmotr.com/v2/',
  development: 'https://teams-api.development.rmotr.com/v2/'
};
var RECOMMENDATION_API_URLS = {
  test: 'https://recommendation-api.development.rmotr.com/',
  production: 'https://recommendation-api.rmotr.com/',
  staging: 'https://recommendation-api.staging.rmotr.com/',
  local: 'https://recommendation-api.development.rmotr.com/',
  development: 'https://recommendation-api.development.rmotr.com/'
};

var fallbackMessage = 'Network error. Cannot reach INE services.';
var fallbackStatus = 503;

var createFriendlyError = function createFriendlyError(message) {
  var _a;

  return (_a = FRIENDLY_ERRORS[message]) !== null && _a !== void 0 ? _a : message;
};

var djangoErrorHandler = function djangoErrorHandler(errorObj) {
  var _a, _b, _c, _d, _e, _f;

  var status = (_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : fallbackStatus;
  var message = (_e = (_d = (_c = errorObj === null || errorObj === void 0 ? void 0 : errorObj.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.detail) !== null && _e !== void 0 ? _e : fallbackMessage;

  if ((_f = errorObj === null || errorObj === void 0 ? void 0 : errorObj.response) === null || _f === void 0 ? void 0 : _f.data) {
    return Object.assign(Object.assign({}, errorObj.response.data), {
      http_code: status,
      message: createFriendlyError(message)
    });
  }

  return {
    http_code: status,
    message: createFriendlyError(message)
  };
};
var laravelErrorHandler = function laravelErrorHandler(errorObj) {
  var _a, _b, _c, _d, _e, _f, _g, _h;

  var status = (_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : fallbackStatus;
  var message = (_f = (_e = (_d = (_c = errorObj === null || errorObj === void 0 ? void 0 : errorObj.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : fallbackMessage;

  if ((_h = (_g = errorObj === null || errorObj === void 0 ? void 0 : errorObj.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.error) {
    return Object.assign(Object.assign({}, errorObj.response.data.error), {
      message: createFriendlyError(message)
    });
  }

  return {
    http_code: status,
    message: createFriendlyError(message)
  };
};

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var jwtDecode = require('jwt-decode');

var getDomain = function getDomain() {
  var _a;

  var env = getEnv();
  return (_a = COOKIES.DOMAINS[env]) !== null && _a !== void 0 ? _a : COOKIES.DOMAINS.production;
};

var getUAAUrl = function getUAAUrl() {
  var _a;

  var env = getEnv();
  return (_a = UAA_URLS[env]) !== null && _a !== void 0 ? _a : UAA_URLS.production;
};

var cookieAttributes = function cookieAttributes() {
  return {
    expires: 365,
    path: '/',
    domain: getDomain(),
    secure: false
  };
};

var getAccessToken = function getAccessToken() {
  var _a;

  var env = getEnv();
  return (_a = Cookies.get(COOKIES.TYPES.ACCESS[env])) !== null && _a !== void 0 ? _a : '';
};
var setAccessToken = function setAccessToken(accessToken) {
  var env = getEnv();
  Cookies.set(COOKIES.TYPES.ACCESS[env], accessToken, cookieAttributes());
};
var getOriginalAccessToken = function getOriginalAccessToken() {
  var _a;

  var env = getEnv();
  return (_a = Cookies.get(COOKIES.TYPES.ORIGINAL_USER_ACCESS_TOKEN[env])) !== null && _a !== void 0 ? _a : '';
};
var setOriginalAccessToken = function setOriginalAccessToken(accessToken) {
  var env = getEnv();
  Cookies.set(COOKIES.TYPES.ORIGINAL_USER_ACCESS_TOKEN[env], accessToken, cookieAttributes());
};
var removeAccessToken = function removeAccessToken() {
  var env = getEnv();
  Cookies.remove(COOKIES.TYPES.ACCESS[env], cookieAttributes());
};
var removeOriginalAccessToken = function removeOriginalAccessToken() {
  var env = getEnv();
  Cookies.remove(COOKIES.TYPES.ORIGINAL_USER_ACCESS_TOKEN[env], cookieAttributes());
};
var removeAllTokens = function removeAllTokens() {
  removeAccessToken();
  removeOriginalAccessToken();
};
var fetchNewTokens = function fetchNewTokens(originalRequest) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var accessToken, route, _yield$axios$post, newAccessToken;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            accessToken = getAccessToken();
            route = "".concat(getUAAUrl(), "/auth/refresh-token");
            _context.next = 5;
            return axios.post(route, null, {
              headers: {
                authorization: "Bearer ".concat(accessToken)
              }
            });

          case 5:
            _yield$axios$post = _context.sent;
            newAccessToken = _yield$axios$post.data.data.tokens.data.Bearer;
            setAccessToken(newAccessToken);
            originalRequest.headers.Authorization = "Bearer ".concat(getAccessToken());
            return _context.abrupt("return", originalRequest);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            removeAllTokens();
            throw _context.t0;

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));
};
var checkToken = function checkToken(accessToken) {
  var isExpired = false;

  if (accessToken) {
    var _jwtDecode = jwtDecode(accessToken),
        exp = _jwtDecode.exp;

    if (!exp) {
      throw new Error('Invalid Expiration');
    }

    var expireTime = fromUnixTime(exp);
    var currentTime = add(new Date(), {
      minutes: 10
    });
    isExpired = isBefore(expireTime, currentTime);
  }

  return isExpired;
};
var checkAndRefreshToken = function checkAndRefreshToken(config) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var request, accessToken, isExpired, refresh;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            request = {};
            accessToken = getAccessToken();

            if (!accessToken) {
              _context2.next = 21;
              break;
            }

            _context2.prev = 3;
            isExpired = checkToken(accessToken);

            if (!isExpired) {
              _context2.next = 12;
              break;
            }

            _context2.next = 8;
            return fetchNewTokens(config);

          case 8:
            refresh = _context2.sent;
            request = Object.assign({}, refresh);
            _context2.next = 13;
            break;

          case 12:
            request = Object.assign(Object.assign({}, config), {
              headers: Object.assign(Object.assign({}, config.headers), {
                Authorization: "Bearer ".concat(accessToken)
              })
            });

          case 13:
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](3);
            removeAllTokens();
            throw _context2.t0;

          case 19:
            _context2.next = 22;
            break;

          case 21:
            request = Object.assign({}, config);

          case 22:
            return _context2.abrupt("return", request);

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 15]]);
  }));
};

var inePromiseAll = function inePromiseAll(requests, callback) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var isAuthenticated, isImpersonating, includedRequests;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!requests) {
              _context2.next = 15;
              break;
            }

            _context2.prev = 1;
            isAuthenticated = !!getAccessToken();
            isImpersonating = !!getOriginalAccessToken();
            includedRequests = requests.filter(function (request) {
              return !request.exclude;
            });

            if (!(!isImpersonating && isAuthenticated && includedRequests.length > 1)) {
              _context2.next = 8;
              break;
            }

            _context2.next = 8;
            return callback();

          case 8:
            _context2.next = 10;
            return Promise.all(_toConsumableArray(includedRequests.map(function (_ref) {
              var action = _ref.action;
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return action();

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
            })));

          case 10:
            _context2.next = 15;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](1);
            throw _context2.t0;

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 12]]);
  }));
};

var passwordHasLowercase = function passwordHasLowercase(value) {
  return /[a-z]/.test(value);
};
var passwordHasUppercase = function passwordHasUppercase(value) {
  return /[A-Z]/.test(value);
};
var passwordHasANumber = function passwordHasANumber(value) {
  return /[0-9]/.test(value);
};
var passwordHasCorrectLength = function passwordHasCorrectLength(_ref) {
  var value = _ref.value,
      requiredLength = _ref.requiredLength;
  return value.length >= requiredLength;
};
var passwordHasAllowedCharacters = function passwordHasAllowedCharacters(value) {
  if (/^\s|\s$/.test(value)) return false;
  var regex = /^[a-zA-Z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\-\s]+$/;
  return regex.test(value);
};
var isPasswordValid = function isPasswordValid(_ref2) {
  var value = _ref2.value,
      requiredLength = _ref2.requiredLength;
  return passwordHasLowercase(value) && passwordHasUppercase(value) && passwordHasANumber(value) && passwordHasAllowedCharacters(value) && passwordHasCorrectLength({
    value: value,
    requiredLength: requiredLength
  });
};

var setupClients = function setupClients(env) {
  var apiUrls = {
    API: API_URLS[env],
    UAA: UAA_URLS[env],
    UAA_ANONYMOUS: UAA_URLS[env],
    QUIZ: QUIZ_URLS[env],
    FILES: FILE_URLS[env],
    VIDEOS: VIDEO_URLS[env],
    IFRAME: IFRAME_URLS[env],
    CONTENT: CONTENT_URLS[env],
    PROFILE: PROFILE_URLS[env],
    BUSINESS: BUSINESS_URLS[env],
    MIXPANEL: MIXPANEL_URLS[env],
    EXERCISES: EXERCISE_URLS[env],
    STATISTICS: STATISTIC_URLS[env],
    SUBSCRIPTIONS: SUBSCRIPTION_URLS[env],
    CERTIFICATIONS: CERTIFICATION_URLS[env],
    BUSINESS_PYTHON: BUSINESS_PYTHON_URLS[env],
    BUSINESS_PYTHON_ANONYMOUS: BUSINESS_PYTHON_URLS[env],
    REPORTING: REPORTING_URLS[env],
    REPORTING_v2: REPORTING_v2_URLS[env],
    TEAMS_API: TEAMS_API_URLS[env],
    TEAMS_API_v2: TEAMS_API_v2_URLS[env],
    CONTENT_BACKOFFICE: CONTENT_BACKOFFICE_URLS[env],
    RECOMMENDATION_API: RECOMMENDATION_API_URLS[env]
  };
  var setup = {
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      common: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      post: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  };

  var applyDefaultRequestInterceptors = function applyDefaultRequestInterceptors(clients) {
    clients.map(function (client) {
      client.interceptors.request.use(function (config) {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var request;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return checkAndRefreshToken(config);

                case 2:
                  request = _context.sent;
                  return _context.abrupt("return", request);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      });
      client.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        throw error;
      });
    });
  };

  var applyAnonymousRequestInterceptors = function applyAnonymousRequestInterceptors(clients) {
    clients.map(function (client) {
      client.interceptors.request.use(function (request) {
        return request;
      }, function (error) {
        throw error;
      });
      client.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        throw error;
      });
    });
  };

  var UAA = axios.create(Object.assign({
    baseURL: apiUrls.UAA
  }, setup));
  var UAA_ANONYMOUS = axios.create(Object.assign({
    baseURL: apiUrls.UAA
  }, setup));
  var QUIZ = axios.create(Object.assign({
    baseURL: apiUrls.QUIZ
  }, setup));
  var FILES = axios.create(Object.assign({
    baseURL: apiUrls.FILES
  }, setup));
  var VIDEOS = axios.create(Object.assign({
    baseURL: apiUrls.VIDEOS
  }, setup));
  var CONTENT = axios.create(Object.assign({
    baseURL: apiUrls.CONTENT
  }, setup));
  var CONTENT_BACKOFFICE = axios.create(Object.assign({
    baseURL: apiUrls.CONTENT_BACKOFFICE
  }, setup));
  var PROFILE = axios.create(Object.assign({
    baseURL: apiUrls.PROFILE
  }, setup));
  var BUSINESS = axios.create(Object.assign({
    baseURL: apiUrls.BUSINESS
  }, setup));
  var MIXPANEL = axios.create(Object.assign({
    baseURL: apiUrls.MIXPANEL
  }, setup));
  var EXERCISES = axios.create(Object.assign({
    baseURL: apiUrls.EXERCISES
  }, setup));
  var STATISTICS = axios.create(Object.assign({
    baseURL: apiUrls.STATISTICS
  }, setup));
  var SUBSCRIPTIONS = axios.create(Object.assign({
    baseURL: apiUrls.SUBSCRIPTIONS
  }, setup));
  var CERTIFICATIONS = axios.create(Object.assign({
    baseURL: apiUrls.CERTIFICATIONS
  }, setup));
  var BUSINESS_PYTHON = axios.create(Object.assign({
    baseURL: apiUrls.BUSINESS_PYTHON
  }, setup));
  var BUSINESS_PYTHON_ANONYMOUS = axios.create(Object.assign({
    baseURL: apiUrls.BUSINESS_PYTHON
  }, setup));
  var API = axios.create(Object.assign(Object.assign({
    baseURL: apiUrls.API
  }, setup), {
    headers: {
      Accept: 'application/json; version=2.0.0'
    }
  }));
  var IFRAME = axios.create(Object.assign(Object.assign({
    baseURL: apiUrls.IFRAME
  }, setup), {
    withCredentials: true
  }));
  var REPORTING = axios.create(Object.assign({
    baseURL: apiUrls.REPORTING
  }, setup));
  var REPORTING_V2 = axios.create(Object.assign({
    baseURL: apiUrls.REPORTING_v2
  }, setup));
  var TEAMS_API = axios.create(Object.assign({
    baseURL: apiUrls.TEAMS_API
  }, setup));
  var TEAMS_API_V2 = axios.create(Object.assign({
    baseURL: apiUrls.TEAMS_API_v2
  }, setup));
  var RECOMMENDATION_API = axios.create(Object.assign({
    baseURL: apiUrls.RECOMMENDATION_API
  }, setup));
  applyDefaultRequestInterceptors([UAA, QUIZ, FILES, IFRAME, VIDEOS, CONTENT, PROFILE, BUSINESS, MIXPANEL, EXERCISES, STATISTICS, SUBSCRIPTIONS, CERTIFICATIONS, BUSINESS_PYTHON, REPORTING, REPORTING_V2, TEAMS_API, TEAMS_API_V2, CONTENT_BACKOFFICE, RECOMMENDATION_API]);
  applyAnonymousRequestInterceptors([BUSINESS_PYTHON_ANONYMOUS, UAA_ANONYMOUS]);
  return {
    API: API,
    UAA: UAA,
    UAA_ANONYMOUS: UAA_ANONYMOUS,
    QUIZ: QUIZ,
    FILES: FILES,
    IFRAME: IFRAME,
    VIDEOS: VIDEOS,
    CONTENT: CONTENT,
    PROFILE: PROFILE,
    BUSINESS: BUSINESS,
    MIXPANEL: MIXPANEL,
    EXERCISES: EXERCISES,
    STATISTICS: STATISTICS,
    SUBSCRIPTIONS: SUBSCRIPTIONS,
    CERTIFICATIONS: CERTIFICATIONS,
    BUSINESS_PYTHON: BUSINESS_PYTHON,
    BUSINESS_PYTHON_ANONYMOUS: BUSINESS_PYTHON_ANONYMOUS,
    REPORTING: REPORTING,
    REPORTING_V2: REPORTING_V2,
    TEAMS_API: TEAMS_API,
    TEAMS_API_V2: TEAMS_API_V2,
    CONTENT_BACKOFFICE: CONTENT_BACKOFFICE,
    RECOMMENDATION_API: RECOMMENDATION_API
  };
};

export { API_URLS, BUGSNAG, BUSINESS_PYTHON_URLS, BUSINESS_URLS, CERTIFICATION_URLS, CONTENT_BACKOFFICE_URLS, CONTENT_URLS, COOKIES, EXERCISE_URLS, FILE_URLS, FRIENDLY_ERRORS, IFRAME_URLS, KNOWN_API_ERRORS, LAB_URLS, MIXPANEL_URLS, PROFILE_URLS, QUIZ_URLS, RECOMMENDATION_API_URLS, REPORTING_URLS, REPORTING_v2_URLS, STATISTIC_URLS, SUBSCRIPTION_URLS, TEAMS_API_URLS, TEAMS_API_v2_URLS, UAA_URLS, VIDEO_URLS, checkAndRefreshToken, checkToken, djangoErrorHandler, fetchNewTokens, getAccessToken, getEnv, getOriginalAccessToken, inePromiseAll, isPasswordValid, laravelErrorHandler, passwordHasANumber, passwordHasAllowedCharacters, passwordHasCorrectLength, passwordHasLowercase, passwordHasUppercase, removeAccessToken, removeAllTokens, removeOriginalAccessToken, setAccessToken, setEnv, setOriginalAccessToken, setupClients, setupJsCommon };
